import React  from "react";
import { Trans } from "react-i18next";

function ColoredPrivilegeName({ name, color, values }) {
  return <Trans i18nKey={`privileges.${name}`} values={values} tOptions={{ interpolation: { escapeValue: true }}} shouldUnescape
  >privilege becomes <span style={{color, fontWeight: "bold"}}>variant</span></Trans>
}

export default ColoredPrivilegeName;
